import { PspContext } from "@/config/contexts";
import { useContext } from "react";

export function useAttendanceVociListElement() {
  const { lang } = useContext(PspContext);

  return { lang };
}
